import { submitOriginalDelivery } from '../actions';

export default {
  [submitOriginalDelivery.toString()]: (state, action) => ({
    ...state,
    formStatus: 'submitting',
    error: undefined,
  }),
};
